import React from 'react';
import Link from 'gatsby-link';
import HeroSection from '../sections/heroSection';
import SpeakerSection from '../sections/speakerSection';
import AboutSection from '../sections/aboutSection';
import CountdownSection from '../sections/countdownSection';
import ScheduleSection from '../sections/scheduleSection';
import TravelSection from '../sections/travelSection';
import VenueSection from '../sections/venueSection';
import RegisterSection from '../sections/registerSection';
import SessionsSection from '../sections/sessionsSection';
import SponsorsSection from '../sections/sponsorsSection';

import '../styles/contentDeck.scss';



const IndexPage = () => (
  <div>
    {/* Hero */}
    <HeroSection/>

    {/* Countdown */}
    <CountdownSection/>

    {/* About */}
    <AboutSection/>

    {/* Speakers */}
    <SpeakerSection/>

    {/* Schedule */}
    <ScheduleSection/>
    {/* Sessions */}
    {/* <SessionsSection/> */}

    {/* Travel */}
    <VenueSection/>
    <TravelSection/>

    {/* Register */}
    <RegisterSection/>

    {/* Sponsors */}
    <SponsorsSection/>


    {/* Footer */}
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js